import { render, staticRenderFns } from "./supplierSettlement.vue?vue&type=template&id=6df37b2e&"
import script from "./supplierSettlement.vue?vue&type=script&lang=js&"
export * from "./supplierSettlement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports